import * as Yup from 'yup';
import { USER_TYPE } from 'store/constant';

const userEditSchema = Yup.object({
    firstname: Yup.string()
        .trim()
        .max(50, 'Must be 50 characters or less')
        .required('First name is required'),
    lastname: Yup.string()
        .trim()
        .max(50, 'Must be 50 characters or less')
        .notRequired(),
    email: Yup.string()
        .trim()
        .email('Invalid email address')
        .required('Email is required'),
    phone: Yup.string()
        .trim()
        .matches(/^[+0-9]+$/, 'Invalid phone number')
        .min(10, 'Invalid phone number')
        .max(10, 'Invalid phone number')
        .required('Valid phone number is required'),
    uuid_venue: Yup.array()
        .when('type', {
            is: USER_TYPE[0].value,
            then: Yup.array()
                .of(
                    Yup.string().required('Venue is required')
                )
                .min(1, 'At least one venue is required'),
            otherwise: Yup.array().notRequired()
        }),
    image: Yup.string()
        .notRequired(),
    dob: Yup.string()
        .notRequired()
        .nullable(),
    countrycode: Yup.string()
        .trim()
        .max(2, 'Must be 2 characters or less')
        .min(2, 'Must be 2 characters or less')
        .required('Country code is required'),
    type: Yup.string()
        .trim()
        .max(50, 'Must be 50 characters or less')
        .required('User type is required'),
    gender: Yup.string()
        .trim()
        .max(50, 'Must be 50 characters or less')
        .required('Gender is required'),
    loc_city: Yup.string()
        .trim()
        .max(50, 'Must be 50 characters or less')
        .required('City is required')
});

export default userEditSchema;